<template>
    <div class="search-box">
        <div class="search">
            <i class="iconfont icon-icon-video-search"></i>
            <input type="text" placeholder="请输入关键字搜索" placeholder-class="input-font" @keyup.enter="toSearch"
                v-model="searchKey" />
            <i class="iconfont icon-clear" @click="clearSearch"></i>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                searchKey: "",
            }
        },
        methods: {
            toSearch() {
                this.$emit('toSearch', this.searchKey)
            },
            clearSearch() {
                this.searchKey = ""
                this.$emit('toSearch', this.searchKey)
            }
        }
    }
</script>

<style>

</style>